import React, {useEffect} from 'react';
import {ReactComponent as BackIcon} from '../../../../../assets/main/groups/main-top/back.svg';
import {useAppDispatch, useAppSelector} from "common/hook";
import {MainTop} from "../../group-container/main-top/Main-top";
import AuthWrapper from "../../../../auth-wrapper/AuthWrapper";
import {fetchLessonsDemo} from "features/model/service/lessons/lessons-demo/fetchLessonsDemo";
import {ROLE_DEMO_STUDENT} from "entities/constants/constants";
import {MainTableDemo} from "./main-table-demo/MainTableDemo";


export const LessonsDemo = () => {
    const dispatch = useAppDispatch();
    const activeTabs = useAppSelector((state) => state.topTabs.activeTabs);
    const roleType = useAppSelector((state) => state.role.roleType);


    useEffect(() => {
        dispatch(fetchLessonsDemo({}));
    }, [dispatch]);


    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop
                    title={'Демо Уроки'} tabs={false} setting={true} link={'/'} icons={<BackIcon/>}/>
                    {roleType === ROLE_DEMO_STUDENT && activeTabs.includes(0) ? <MainTableDemo />: null}
            </div>
        </AuthWrapper>
    );

};